import { useEffect, MutableRefObject } from "react";

/**
 * Hook that alerts clicks outside of the passed ref
 */
const useOutsideAlerter = (
  refs: MutableRefObject<any>[],
  alertCallback?: () => void
) => {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event: MouseEvent) {
      event.stopPropagation();

      const isOutsideAllRefs = refs.every((ref) => {
        const refCurrent = ref.current;
        const containsTarget = refCurrent
          ? refCurrent.contains(event.target)
          : false;

        return refCurrent ? !containsTarget : true; // Handle null ref as outside
      });

      if (isOutsideAllRefs && alertCallback) {
        alertCallback();
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside, {
      passive: true,
    });
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [refs, alertCallback]);
};

export default useOutsideAlerter;
